module.exports = __webpack_public_path__ + "static/What-Physical-Fixes-Can-You-Try-for-Immediate-Relief-0e11b7899b2d9b4fb09c407a2be40022.webp";